import { Store } from '@toeverything/infra';

import { getCookie, getVisitorIdByCookie } from '../server/utils';
import { getApiUrl } from '../server/config';
import request from '../server/base';

export class UserCreditsDetailStore extends Store {
  constructor() {
    super();
  }

  async fetchUserCreditsDetail() {
    const visitorId = getVisitorIdByCookie();
    const auth = getCookie('login')
      ? JSON.parse(decodeURIComponent(getCookie('login') || '') || '')
      : null;
    const config = {
      url: `${getApiUrl()}/trade/wallet/balances-by-tag?assetTypeCode=CREDIT`,
      method: 'GET',
      headers: {
        'X-Yuanshi-Authorization': 'Bearer ' + auth?.token,
        'X-Yuanshi-DeviceId': visitorId,
        // userId: auth?.user?.id,
      },
    };
    const res = await request(config);

    // const data = await this.graphqlService.gql({
    //   query: copilotQuotaQuery,
    //   context: {
    //     signal: abortSignal,
    //   },
    // });

    return res;
  }

  async fetchTransactionsList(params: { page: number; pageSize: number }) {
    const visitorId = getVisitorIdByCookie();
    const auth = getCookie('login')
      ? JSON.parse(decodeURIComponent(getCookie('login') || '') || '')
      : null;
    const config = {
      url: `${getApiUrl()}/trade/transactions/list?assetTypeCode=CREDIT&page=${params.page}&pageSize=${params.pageSize}`,
      method: 'GET',
      headers: {
        'X-Yuanshi-Authorization': 'Bearer ' + auth?.token,
        'X-Yuanshi-DeviceId': visitorId,
        // userId: auth?.user?.id,
      },
    };
    const res = await request(config);
    return res;
  }
}
